/* main.js
--------------------------------------------------------------------------------

MAIN JS [ TABLE OF CONTENTS ]


VARIABLES
--------------------------------------------------------------------------------
Main Variables


LAYOUT
--------------------------------------------------------------------------------
1.1   Sidebar Toggle
1.2   Sidebar Switcher
1.3   Dark/Light Mode Toggle


INIT FUNCTIONS
--------------------------------------------------------------------------------
A.1   Window Load Function
A.2   Document Ready Function
A.3   Window Resize Function

--------------------------------------------------------------------------------
*/



(function($) {
	"use strict";

  // VARIABLES
  // ---------------------------------------------------------------------------
  let toggleButton =  $('.topbar--toggle .btn-toggle');
  let closeButton =   $('.sidebar--header .btn-close');
	let sidebarMain =   $('.sidebar');
	let switchButton =  $('.sidebar--switcher .switcher-button');
  let toggleTarget =  $('body');


  // LAYOUT
  // ---------------------------------------------------------------------------
  // 1.1   Sidebar Toggle
  function init_sidebarToggle() {
    // Show sidebar
    toggleButton.on('click', function() {
      toggleTarget.toggleClass('sidebar-is-active')
    })
    // Hide sidebar
    closeButton.on('click', function() {
      toggleTarget.removeClass('sidebar-is-active')
    })
  }

	// 1.2   Sidebar Switcher
	function init_sidebarSwitcher() {
		switchButton.on('click', function() {
      sidebarMain.toggleClass('switcher-is-active')
    })
	}

	// 1.3   Dark/Light Mode Toggle
	function init_demoToggleMode() {
		$('#demoToggleMode').on('click', function() {
			if($('body').hasClass('dark-mode-active')){
				$('body').removeClass('dark-mode-active');
				sessionStorage.setItem('color', 'light');
			}else{
				$('body').addClass('dark-mode-active');
				sessionStorage.setItem('color', 'dark');
			}
    });

	}




  // INIT FUNCTIONS

  // ---------------------------------------------------------------------------
  // A.1  WINDOW LOAD FUNCTIONS

	$(window).on('load', function() {

	});


  // ---------------------------------------------------------------------------
	// A.2 DOCUMENT READY FUNCTIONS

  jQuery(document).ready(function($) {

		// Remove preload class used to prevent CSS Transitions
		$("body").removeClass("preload");

    init_sidebarToggle();               // 1.1  Sidebar Toggle
		init_sidebarSwitcher();							// 1.2	Sidebar Switcher
		init_demoToggleMode();							// 1.3  Dark/Light Mode Toggle

	});


  // ---------------------------------------------------------------------------
	// A.3 WINDOW RESIZE FUNCTIONS

  $(window).on('resize', function () {

    // 1.1  Sidebar Toggle (If window resizes hide the sidebar)
    toggleTarget.removeClass('sidebar-is-active');


	});



})(jQuery);
